export default __webpack_public_path__ + "static/media/harmonyavond.f448ed14.jpeg";